export default __webpack_public_path__ + "static/media/ic_fullscreen01.f1aaa03d.svg";